import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

const fetchMeta = () => api.get("/meta").then((r) => { cache = r.data; listeners.forEach((fn) => fn(r.data)); }).catch(() => {});

export const refreshMeta = () => fetchMeta();

export function useMeta() {
  const [meta, setMeta] = useState(cache);
  useEffect(() => {
    listeners.add(setMeta);
    if (!cache) fetchMeta();
    return () => listeners.delete(setMeta);
  }, []);
  return meta;
}

export const fromPrice = (meta) => (meta ? Math.min(...meta.bands.map((b) => b.standard)) : null);
